import { doc, onSnapshot, DocumentSnapshot } from 'firebase/firestore';
import { useState, useEffect } from 'react';
import { db } from '../config/firebase';
import { PMT2SyncStatus } from '../types/pmt2Types';

/**
 * Custom hook to fetch and subscribe to PMT3 sync status
 */
const usePmt3SyncStatus = () => {
  const [syncStatus, setSyncStatus] = useState<PMT2SyncStatus | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    // Reference to the sync status document
    const syncStatusRef = doc(db, 'pmt2_sync_status', 'latest');
    
    // Set up the listener
    const unsubscribe = onSnapshot(
      syncStatusRef,
      {
        includeMetadataChanges: true
      },
      (snapshot: DocumentSnapshot) => {
        setLoading(false);
        if (snapshot.exists()) {
          // Cast the data to our type
          const data = snapshot.data() as PMT2SyncStatus;
          setSyncStatus(data);
        } else {
          setSyncStatus(null);
        }
      },
      (err: Error) => {
        console.error('Error fetching sync status:', err);
        setError(err);
        setLoading(false);
      }
    );

    // Clean up the listener when the component unmounts
    return () => unsubscribe();
  }, []);

  return { syncStatus, loading, error };
};

export default usePmt3SyncStatus;